import { createAsyncActions } from '../../utils';

export const searchConstants = {
  SET_FORM_DATA: '@@search/SET_FORM_DATA',
  RESET_FORM_DATA: '@@search/RESET_FORM_DATA',
  SEARCH_CANDIDATES: createAsyncActions('@@search/SEARCH_CANDIDATES'),
  APPLY_FILTERS: createAsyncActions('@@search/APPLY_FILTERS'),
  LOAD_MORE_CANDIDATES: createAsyncActions('@@search/LOAD_MORE_CANDIDATES'),
  SET_SEARCH_RESULTS: '@@search/SET_SEARCH_RESULTS',
  UPDATE_FILTERS: '@@search/UPDATE_FILTERS',
  APPEND_CANDIDATES: '@@search/APPEND_CANDIDATES',
};
export const searchActions = {

  updateFilters: (payload) => ({
    type: searchConstants.UPDATE_FILTERS,
    payload,
  }),
  applyFilters: (payload) => ({
    type: searchConstants.APPLY_FILTERS.TRIGGER,
    payload,
  }),
  setSearchFormData: (payload, meta) => ({
    type: searchConstants.SET_FORM_DATA, payload, meta,
  }),
  resetSearchFormData: () => ({
    type: searchConstants.RESET_FORM_DATA,
  }),
  searchCandidates: (payload) => ({
    type: searchConstants.SEARCH_CANDIDATES.TRIGGER, payload,
  }),
  setSearchResults: (results, meta) => ({
    type: searchConstants.SET_SEARCH_RESULTS,
    payload: results,
    meta,
  }),
  loadMoreCandidates: (payload) => ({
    type: searchConstants.LOAD_MORE_CANDIDATES.TRIGGER, payload,
  }),
  appendCandidates: (payload) => ({
    type: searchConstants.APPEND_CANDIDATES,
    payload,
  }),
};
